import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import slugify from '@sindresorhus/slugify';
import { styled } from '@mui/system';
import { getLocalizedPath } from 'helpers/getLocale';

const DecoLink = styled('div')(() => ({
  '& > *': {
    textDecoration: 'none'
  },
  '& a': {
    display: 'block',
    height: '100%'
  }
}));

const CustomLink = ({
  children,
  externalLink,
  getRedirectUrl,
  endPoint,
  title,
  number,
  universityName,
  lang,
  _id,
  props,
  ...otherProps
}) => {
  const navigate = useNavigate();

  const evalRedirect = React.useCallback(() => {
    if (typeof getRedirectUrl === 'function') {
      return getRedirectUrl(props);
    }
    return null;
  }, [getRedirectUrl, props]);

  const isExternal = React.useMemo(() => {
    return externalLink && typeof getRedirectUrl === 'function' && evalRedirect();
  }, [externalLink, getRedirectUrl, evalRedirect]);

  const redirectUrl = React.useMemo(() => {
    const getSlug = () => {
      const slugText = title || number || universityName || props[`firstName${lang}`] + props[`lastName${lang}`] || 'item';
      return slugify(slugText || 'item');
    };

    return evalRedirect() || `${endPoint}/${getSlug()}/${_id}`;
  }, [props, endPoint, title, number, universityName, lang, _id, evalRedirect]);

  const handleClick = React.useCallback(
    (e) => {
      e.preventDefault();

      if (isExternal) {
        window.open(redirectUrl, '_blank');
        return;
      }

      navigate(getLocalizedPath(`/${redirectUrl}`));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    [navigate, redirectUrl, isExternal]
  );

  if (isExternal) {
    return (
      <DecoLink>
        <a {...otherProps} href={redirectUrl} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      </DecoLink>
    );
  }

  return (
    <DecoLink>
      <Link to={getLocalizedPath(`/${redirectUrl}`)} onClick={handleClick} {...otherProps}>
        {children}
      </Link>
    </DecoLink>
  );
};

export default CustomLink;
